import React from "react";
import { Icon, Switch } from "../";
import CreateCategoryModal from "./CreateCategoryModal";

const CategoriesList = ({
  categories,
  selectedCategoryId,
  onSelectCategory,
  onToggleCategory,
  selectedBusinessSlug,
  isLoadingToggle,
  hasPosIntegration,
  businessId,
  onCategoryDeleted,
}) => {
  const [isCreateOpen, setIsCreateOpen] = React.useState(false);
  const [categoryToEdit, setCategoryToEdit] = React.useState(null);

  const flattenCategories = (cats, level = 0) => {
    const result = [];
    cats.forEach((cat) => {
      result.push({ ...cat, level });
      if (cat.subcategories && cat.subcategories.length > 0) {
        result.push(...flattenCategories(cat.subcategories, level + 1));
      }
    });
    return result;
  };

  const flatCategories = flattenCategories(categories);

  const handleCategoryClick = (category) => {
    onSelectCategory(category.id);
  };

  const handleEditCategory = (e, category) => {
    e.stopPropagation();
    setCategoryToEdit(category);
    setIsCreateOpen(true);
  };

  return (
    <div className="flex h-full flex-col rounded-lg border border-gray-800 bg-gray-900">
      {/* Header */}
      <div className="min-h-[36px] border-b border-gray-800 p-4 sm:min-h-[40px]">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Folder" className="h-5 w-5 text-gray-400" />
            <h3 className="text-lg font-semibold text-white">Categories</h3>
          </div>
          {!hasPosIntegration && (
            <button
              className="flex items-center gap-1 rounded bg-blue-600 px-3 py-2 text-sm text-white hover:bg-blue-700"
              onClick={() => {
                setCategoryToEdit(null);
                setIsCreateOpen(true);
              }}
            >
              <Icon name="Plus" className="h-4 w-4" /> Add Category
            </button>
          )}
        </div>
      </div>

      {/* Categories List */}
      <div className="flex-1 overflow-y-auto p-4">
        {flatCategories.length > 0 ? (
          <div className="space-y-2">
            {flatCategories.map((category) => (
              <div
                key={category.id}
                className={`flex cursor-pointer items-center justify-between rounded-lg border p-3 transition-colors ${
                  selectedCategoryId === category.id
                    ? "border-blue-500 bg-blue-500/10"
                    : "border-gray-700 bg-gray-800 hover:border-gray-600"
                }`}
                style={{ marginLeft: `${category.level * 0.75}rem` }}
                onClick={() => handleCategoryClick(category)}
              >
                <div className="min-w-0 flex-1">
                  <div className="flex items-center space-x-2">
                    <span className="truncate text-sm font-medium text-white">
                      {category.name}
                    </span>
                  </div>
                </div>
                <div
                  className="flex items-center gap-2"
                  onClick={(e) => e.stopPropagation()}
                >
                  {!hasPosIntegration && (
                    <button
                      onClick={(e) => handleEditCategory(e, category)}
                      className="rounded-md p-1.5 text-gray-400 hover:bg-gray-700 hover:text-blue-400"
                      aria-label="Edit category"
                      title="Edit category"
                    >
                      <Icon name="Edit" className="h-4 w-4" />
                    </button>
                  )}
                  <Switch
                    checked={!!category.enabled}
                    onCheckedChange={(value) => {
                      if (onToggleCategory) {
                        onToggleCategory(category.id, value);
                      }
                    }}
                    disabled={isLoadingToggle}
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex h-32 items-center justify-center">
            <p className="text-sm text-gray-400">No categories available</p>
          </div>
        )}
      </div>

      {/* Create/Edit Category Modal */}
      <CreateCategoryModal
        isOpen={isCreateOpen}
        onClose={() => {
          setIsCreateOpen(false);
          setCategoryToEdit(null);
        }}
        businessId={businessId}
        selectedBusinessSlug={selectedBusinessSlug}
        categoryToEdit={categoryToEdit}
        onToggleCategory={onToggleCategory}
        onCategoryDeleted={onCategoryDeleted}
        isLoadingToggle={isLoadingToggle}
        hasPosIntegration={hasPosIntegration}
      />
    </div>
  );
};

export default CategoriesList;
